module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sideways-page-one"
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("User Groups")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.permissions['user_manager user_groups create']) ? _c('div', {
    staticClass: "portlet box blue-hoki margin-top-20"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleCreateGroupPanel()
      }
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createGroupCollapse, 'collapse': _vm.createGroupCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.createGroupCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNewGroup()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGroup.name),
      expression: "newGroup.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newGroup.name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newGroup.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGroup, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Group Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGroup.description),
      expression: "newGroup.description"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newGroup.description.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newGroup.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGroup, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Group Description")])]), _vm._v(" "), _c('h4', {
    staticClass: "margin-top-20"
  }, [_vm._v("All users with:")]), _vm._v(" "), _c('div', [_c('el-dropdown', {
    staticClass: "margin-top-15",
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSignUpDate
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.selectedSignUpDate) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": 7
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSigned up in the last 7 days\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 14
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSigned up in the last 14 days\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": 30
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSigned up in the last 30 days\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-dropdown', {
    staticClass: "margin-top-15",
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateTotalOrders
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.selectedTotalOrders) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": [10, '<']
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tLess than 10 orders\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": [25, '>']
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMore than 25 orders\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": [50, '>']
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMore than 50 orders\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.city.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "change": function($event) {
        _vm.addRule('city')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("City")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.province),
      expression: "province"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.province.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.province)
    },
    on: {
      "change": function($event) {
        _vm.addRule('province')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.province = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Province")])])])])]), _vm._v(" "), _vm._m(2, false, false)])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body relative-block"
  }, [_c('div', {
    staticClass: "mt-element-list"
  }, [_c('div', {
    staticClass: "clearfix margin-bottom-10"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tSort by\n\t\t\t\t\t\t\t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.resultsPerPageUpdate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-list-container list-news"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.loadingGroupsData,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groups.length && !_vm.loadingGroupsData),
      expression: "groups.length && !loadingGroupsData"
    }]
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: group.id,
      staticClass: "mt-list-item actions-at-left margin-top-15 clickable",
      attrs: {
        "id": 'group-' + group.id
      },
      on: {
        "click": function($event) {
          _vm.sendMessageToGroup(group)
        }
      }
    }, [_c('div', {
      staticClass: "list-item-actions"
    }, [(_vm.$root.permissions['user_manager user_groups update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.displayEditGroupModal(group, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['user_manager user_groups read'] && !_vm.$root.permissions['user_manager user_groups update']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.displayEditGroupModal(group, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-eye"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['user_manager user_groups delete']) ? _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.deleteGroup(group, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })])]) : _vm._e()], 1), _vm._v(" "), _vm._m(4, true, false), _vm._v(" "), _c('div', {
      staticClass: "list-datetime bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(group.name))])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-content height-mod"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('span', [_vm._v(_vm._s(group.description))])])])])
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numPages > 1),
      expression: "numPages > 1"
    }],
    staticClass: "clearfix"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1)]), _vm._v(" "), (!_vm.groups.length && !_vm.loadingGroupsData) ? _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.groups.length,
      "type": 'store groups'
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.showSelectUsersModal) ? _c('select-users', {
    attrs: {
      "passedGroupId": _vm.selectedGroupId,
      "passedGroupName": _vm.passedGroupName
    },
    on: {
      "closeSelectUsersModal": _vm.closeSelectUsersModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.messageModalDisplayed) ? _c('message', {
    attrs: {
      "userId": _vm.selectedUsers
    },
    on: {
      "closeMessageModal": _vm.closeMessageModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deleteGroupModalActive) ? _c('delete-user-group', {
    attrs: {
      "selectedPromotionId": _vm.groupToBeDeletedId
    },
    on: {
      "closeDeleteGroupModal": _vm.closeDeleteGroupModal,
      "deleteGroupAndCloseModal": _vm.deleteGroupAndCloseModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditGroupModal) ? _c('edit-user-group', {
    attrs: {
      "passedGroup": _vm.groupToBeEdited
    },
    on: {
      "closeEditGroupModal": _vm.closeEditGroupModal,
      "updateGroup": _vm.updateGroup
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("A list of user groups for PitaPit.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("\n\t\t\t\t\t\tCreate New Group\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-actions right"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/client_logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("User Groups")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("Click on a group to send a message to its members.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-icon-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a90b9328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UserManager/UserGroups.vue
// module id = 773
// module chunks = 0